(function () {
  if (window.SPCLSTMobileQuickAddInitialized) return;
  window.SPCLSTMobileQuickAddInitialized = true;

  var mobileMedia = window.matchMedia('(max-width: 767px)');
  var activeState = null;

  function query(selector, root) {
    return (root || document).querySelector(selector);
  }

  function queryAll(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function getQuickAddButtonState(sizeRequired, selectedSizeValue, sourceButtonAvailable) {
    if (sizeRequired && !selectedSizeValue) {
      return { disabled: true, label: 'SELECT A SIZE' };
    }

    if (!sourceButtonAvailable) {
      return { disabled: true, label: 'SOLD OUT' };
    }

    return { disabled: false, label: 'ADD TO CART' };
  }

  function getSourceOptionButtons(card, optionKind) {
    return queryAll('[data-option-kind="' + optionKind + '"][data-option-index][data-option-value]', card);
  }

  function getActiveOptionValue(card, optionKind) {
    var activeButton = getSourceOptionButtons(card, optionKind).find(function (button) {
      return button.classList.contains('is-active');
    });

    return activeButton ? activeButton.getAttribute('data-option-value') || '' : '';
  }

  function getActiveOptionSelection(card) {
    var selected = {};

    queryAll('[data-option-index][data-option-value].is-active', card).forEach(function (button) {
      selected[button.getAttribute('data-option-index')] = button.getAttribute('data-option-value');
    });

    return selected;
  }

  function quickAddSelectionMatchesVariant(variant, selectedOptions) {
    if (!variant || !Array.isArray(variant.options)) return false;

    return variant.options.every(function (optionValue, optionIndex) {
      var key = String(optionIndex);
      return !selectedOptions[key] || selectedOptions[key] === optionValue;
    });
  }

  function quickAddOptionAvailable(variants, selectedOptions, optionKind, optionIndex, optionValue) {
    var testSelection = optionKind === 'color' ? {} : Object.assign({}, selectedOptions);
    testSelection[String(optionIndex)] = optionValue;

    return variants.some(function (variant) {
      return variant.available && quickAddSelectionMatchesVariant(variant, testSelection);
    });
  }

  function quickAddColorRequiresSizeReset(variants, colorIndex, colorValue, sizeIndex, sizeValue) {
    if (!sizeValue) return false;

    var testSelection = {};
    testSelection[String(colorIndex)] = colorValue;
    testSelection[String(sizeIndex)] = sizeValue;

    return !variants.some(function (variant) {
      return variant.available && quickAddSelectionMatchesVariant(variant, testSelection);
    });
  }

  function getCardVariants(card) {
    var variantsJson = query('[data-spclst-variants]', card);
    if (!variantsJson) return [];

    try {
      return JSON.parse(variantsJson.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function setCloneActiveState(button, optionKind, isActive) {
    button.classList.toggle('is-active', isActive);
    button.classList.toggle('sf-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

    if (optionKind === 'color') {
      button.classList.toggle('spclst-color-choice--active', isActive);
      var colorBlock = query('.colorblock', button);
      if (colorBlock) colorBlock.classList.toggle('sf-active', isActive);
      return;
    }

    button.classList.toggle('pdpdraftproductsizeselected', isActive);
    button.classList.toggle('pdpdraftproductsizeselector', !isActive);
    var sizeText = query('.plpsizeselectortext', button);
    if (sizeText) sizeText.classList.toggle('sf-active', isActive);
  }

  function cloneOptions(state, optionKind) {
    var sourceButtons = getSourceOptionButtons(state.card, optionKind);
    var target = query('[data-spclst-mobile-quick-add-' + optionKind + '-options]', state.sheet);
    var group = query('[data-spclst-mobile-quick-add-' + optionKind + '-group]', state.sheet);

    if (!target || !group) return sourceButtons;

    target.replaceChildren();
    group.hidden = sourceButtons.length === 0;

    sourceButtons.forEach(function (sourceButton) {
      var clone = sourceButton.cloneNode(true);
      var optionIndex = sourceButton.getAttribute('data-option-index') || '';
      var optionValue = sourceButton.getAttribute('data-option-value') || '';
      var isActive =
        optionKind === 'size'
          ? Boolean(state.selectedSizeValue && state.selectedSizeValue === optionValue)
          : sourceButton.classList.contains('is-active');
      var optionAvailable = state.variants.length
        ? quickAddOptionAvailable(
            state.variants,
            getActiveOptionSelection(state.card),
            optionKind,
            optionIndex,
            optionValue
          )
        : !sourceButton.disabled;
      var optionSelectable = optionKind === 'color' || optionAvailable;

      clone.setAttribute('data-spclst-mobile-quick-add-option', '');
      setCloneActiveState(clone, optionKind, isActive);
      clone.disabled = !optionSelectable;
      clone.classList.toggle('is-unavailable', !optionAvailable);
      clone.setAttribute('aria-disabled', optionSelectable ? 'false' : 'true');
      target.appendChild(clone);
    });

    return sourceButtons;
  }

  function getCardProductUrl(card) {
    var titleLink = query('a.product-info-header[href]', card);
    var mediaLink = query('.spclst-plp-media-link[href]', card);
    return (titleLink && titleLink.href) || (mediaLink && mediaLink.href) || '#';
  }

  function updateSheetSummary(state) {
    var titleSource = query('.product-name-thumbnail', state.card);
    var priceSource = query('.price-module-thumbnail', state.card);
    var activeMediaLink = query('.spclst-plp-slide.is-active .spclst-plp-media-link', state.card);
    var titleTarget = query('[data-spclst-mobile-quick-add-title]', state.sheet);
    var priceTarget = query('[data-spclst-mobile-quick-add-price]', state.sheet);
    var imageTarget = query('[data-spclst-mobile-quick-add-image]', state.sheet);
    var imageLinkTarget = query('[data-spclst-mobile-quick-add-image-link]', state.sheet);
    var productUrl = getCardProductUrl(state.card);
    var title = titleSource ? String(titleSource.textContent || '').trim() : '';
    var colorValue = getActiveOptionValue(state.card, 'color');
    var activeColorButton = getSourceOptionButtons(state.card, 'color').find(function (button) {
      return button.classList.contains('is-active');
    });
    var colorOptionIndex = activeColorButton
      ? parseInt(activeColorButton.getAttribute('data-option-index') || '-1', 10)
      : -1;
    var imageValue = activeMediaLink
      ? activeMediaLink.style.getPropertyValue('--spclst-plp-media-image')
      : '';

    if (titleTarget) {
      titleTarget.textContent = title;
      titleTarget.href = productUrl;
    }

    if (priceTarget) {
      priceTarget.innerHTML = priceSource ? priceSource.outerHTML : '';
    }

    if (imageLinkTarget) imageLinkTarget.href = productUrl;

    if (imageTarget) {
      imageTarget.style.backgroundImage = imageValue || 'none';
      imageTarget.setAttribute('aria-label', colorValue ? title + ', ' + colorValue : title);
    }

    var colorValueTarget = query('[data-spclst-mobile-quick-add-color-value]', state.sheet);
    var sizeValueTarget = query('[data-spclst-mobile-quick-add-size-value]', state.sheet);
    var selectedColorAvailable = !colorValue || state.variants.some(function (variant) {
      return variant.available && Array.isArray(variant.options) && variant.options[colorOptionIndex] === colorValue;
    });
    if (colorValueTarget) colorValueTarget.textContent = selectedColorAvailable ? colorValue : 'SOLD OUT';
    if (sizeValueTarget) sizeValueTarget.textContent = state.selectedSizeValue || '';
  }

  function updateSubmitState(state) {
    var sourceButton = query('[data-spclst-plp-add]', state.card);
    var submitButton = query('[data-spclst-mobile-quick-add-submit]', state.sheet);
    var submitLabel = query('[data-spclst-mobile-quick-add-submit-label]', state.sheet);
    var sourceButtonAvailable = Boolean(
      sourceButton && !sourceButton.disabled && sourceButton.getAttribute('aria-disabled') !== 'true'
    );
    var buttonState = getQuickAddButtonState(
      state.sizeRequired,
      state.selectedSizeValue,
      sourceButtonAvailable
    );

    state.buttonState = buttonState;
    if (submitButton) submitButton.disabled = buttonState.disabled;
    if (submitLabel) submitLabel.textContent = buttonState.label;
  }

  function refreshSheet(state) {
    if (!state || !state.card || !state.sheet) return;

    cloneOptions(state, 'color');
    var sizeButtons = cloneOptions(state, 'size');
    state.sizeRequired = sizeButtons.length > 0;
    updateSheetSummary(state);
    updateSubmitState(state);
  }

  function closeQuickAdd(restoreFocus, immediate) {
    if (!activeState) return;

    var state = activeState;
    activeState = null;
    state.sheet.classList.remove('is-open');
    state.sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('spclst-mobile-quick-add-open');

    if (state.sheet.spclstQuickAddCloseTimer) {
      window.clearTimeout(state.sheet.spclstQuickAddCloseTimer);
    }

    if (immediate) {
      state.sheet.hidden = true;
    } else {
      state.sheet.spclstQuickAddCloseTimer = window.setTimeout(function () {
        state.sheet.hidden = true;
        state.sheet.spclstQuickAddCloseTimer = null;
      }, 260);
    }

    if (restoreFocus && state.trigger && typeof state.trigger.focus === 'function') {
      state.trigger.focus({ preventScroll: true });
    }
  }

  function openQuickAdd(trigger) {
    if (!mobileMedia.matches) return false;

    var card = trigger.closest('[data-spclst-collection-card]');
    var sheetId = trigger.getAttribute('aria-controls');
    var sheet = sheetId ? document.getElementById(sheetId) : null;
    if (!card || !sheet) return false;

    if (activeState) closeQuickAdd(false, true);
    if (sheet.spclstQuickAddCloseTimer) {
      window.clearTimeout(sheet.spclstQuickAddCloseTimer);
      sheet.spclstQuickAddCloseTimer = null;
    }

    var sizeButtons = getSourceOptionButtons(card, 'size');
    activeState = {
      buttonState: null,
      card: card,
      variants: getCardVariants(card),
      selectedSizeValue: null,
      sheet: sheet,
      sizeRequired: sizeButtons.length > 0,
      trigger: trigger,
    };

    refreshSheet(activeState);
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('spclst-mobile-quick-add-open');

    var state = activeState;
    window.requestAnimationFrame(function () {
      if (activeState !== state) return;
      sheet.classList.add('is-open');
      var closeButton = query('.spclst-mobile-quick-add__close', sheet);
      if (closeButton) closeButton.focus({ preventScroll: true });
    });

    return true;
  }

  function findSourceOption(state, optionButton) {
    var optionKind = optionButton.getAttribute('data-option-kind');
    var optionIndex = optionButton.getAttribute('data-option-index');
    var optionValue = optionButton.getAttribute('data-option-value');

    return getSourceOptionButtons(state.card, optionKind).find(function (sourceButton) {
      return (
        sourceButton.getAttribute('data-option-index') === optionIndex &&
        sourceButton.getAttribute('data-option-value') === optionValue
      );
    });
  }

  function clearSourceSizeSelection(state) {
    getSourceOptionButtons(state.card, 'size').forEach(function (button) {
      button.classList.remove('is-active');
      setCloneActiveState(button, 'size', false);
    });

    var variantInput = query('[data-spclst-plp-variant-input]', state.card);
    var sourceAddButton = query('[data-spclst-plp-add]', state.card);
    if (variantInput) {
      variantInput.value = '';
    }
    if (sourceAddButton) {
      sourceAddButton.disabled = true;
      sourceAddButton.setAttribute('aria-disabled', 'true');
    }
  }

  function syncSourceSelectedVariant(state) {
    var selectedOptions = getActiveOptionSelection(state.card);
    var variant = state.variants.find(function (candidate) {
      return candidate.available && quickAddSelectionMatchesVariant(candidate, selectedOptions);
    });
    var optionCount = state.variants[0] && Array.isArray(state.variants[0].options)
      ? state.variants[0].options.length
      : 0;
    var selectionComplete = optionCount > 0;

    for (var optionIndex = 0; optionIndex < optionCount; optionIndex += 1) {
      if (!selectedOptions[String(optionIndex)]) selectionComplete = false;
    }

    if (!variant || !selectionComplete) return;

    var variantInput = query('[data-spclst-plp-variant-input]', state.card);
    var sourceAddButton = query('[data-spclst-plp-add]', state.card);
    if (variantInput) {
      variantInput.setAttribute('value', String(variant.id));
      variantInput.value = String(variant.id);
    }
    if (sourceAddButton) {
      sourceAddButton.disabled = false;
      sourceAddButton.setAttribute('aria-disabled', 'false');
    }
  }

  function selectOption(optionButton) {
    if (!activeState || optionButton.disabled) return;

    var state = activeState;
    var optionKind = optionButton.getAttribute('data-option-kind');
    var optionIndex = optionButton.getAttribute('data-option-index') || '';
    var optionValue = optionButton.getAttribute('data-option-value') || '';
    var sourceButton = findSourceOption(state, optionButton);
    if (!sourceButton || (optionKind !== 'color' && sourceButton.disabled)) return;

    if (optionKind === 'color' && state.sizeRequired) {
      var selectedSizeButton = getSourceOptionButtons(state.card, 'size').find(function (button) {
        return button.getAttribute('data-option-value') === state.selectedSizeValue;
      });
      var sizeIndex = selectedSizeButton
        ? selectedSizeButton.getAttribute('data-option-index') || ''
        : '';

      if (
        selectedSizeButton &&
        quickAddColorRequiresSizeReset(
          state.variants,
          optionIndex,
          optionValue,
          sizeIndex,
          state.selectedSizeValue
        )
      ) {
        state.selectedSizeValue = null;
      }
    } else if (optionKind === 'size') {
      state.selectedSizeValue = optionValue;
    }

    if (optionKind === 'color' && sourceButton.disabled) {
      sourceButton.disabled = false;
      sourceButton.setAttribute('aria-disabled', 'false');
    }
    sourceButton.click();
    if (optionKind === 'color' && state.sizeRequired && !state.selectedSizeValue) {
      clearSourceSizeSelection(state);
    } else {
      syncSourceSelectedVariant(state);
    }
    refreshSheet(state);
  }

  function submitQuickAdd() {
    if (!activeState) return;

    var state = activeState;
    refreshSheet(state);
    if (!state.buttonState || state.buttonState.disabled) return;

    var sourceButton = query('[data-spclst-plp-add]', state.card);
    var sourceForm = sourceButton ? sourceButton.closest('form') : null;
    if (
      !sourceButton ||
      !sourceForm ||
      sourceButton.disabled ||
      sourceButton.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    var sheetSubmit = query('[data-spclst-mobile-quick-add-submit]', state.sheet);
    var sheetLabel = query('[data-spclst-mobile-quick-add-submit-label]', state.sheet);
    if (sheetSubmit) sheetSubmit.disabled = true;
    if (sheetLabel) sheetLabel.textContent = 'ADDING TO CART';

    closeQuickAdd(true, false);

    window.requestAnimationFrame(function () {
      if (typeof sourceForm.requestSubmit === 'function') {
        sourceForm.requestSubmit(sourceButton);
      } else {
        sourceButton.click();
      }
    });
  }

  function getFocusableElements(sheet) {
    return queryAll(
      'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])',
      sheet
    ).filter(function (element) {
      return !element.hidden && element.getClientRects().length > 0;
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-spclst-mobile-quick-add-trigger]');
    if (trigger) {
      if (openQuickAdd(trigger)) event.preventDefault();
      return;
    }

    if (!activeState) return;

    var closeTrigger = event.target.closest('[data-spclst-mobile-quick-add-close]');
    if (closeTrigger && activeState.sheet.contains(closeTrigger)) {
      event.preventDefault();
      closeQuickAdd(true, false);
      return;
    }

    var optionButton = event.target.closest('[data-spclst-mobile-quick-add-option]');
    if (optionButton && activeState.sheet.contains(optionButton)) {
      event.preventDefault();
      selectOption(optionButton);
      return;
    }

    var submitButton = event.target.closest('[data-spclst-mobile-quick-add-submit]');
    if (submitButton && activeState.sheet.contains(submitButton)) {
      event.preventDefault();
      submitQuickAdd();
    }
  });

  document.addEventListener('keydown', function (event) {
    var keyboardTrigger = event.target.closest('[data-spclst-mobile-quick-add-trigger]');
    if (keyboardTrigger && event.key === ' ') {
      if (openQuickAdd(keyboardTrigger)) event.preventDefault();
      return;
    }

    if (!activeState) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeQuickAdd(true, false);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusableElements(activeState.sheet);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function handleViewportChange(event) {
    if (!event.matches) closeQuickAdd(false, true);
  }

  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', handleViewportChange);
  } else if (typeof mobileMedia.addListener === 'function') {
    mobileMedia.addListener(handleViewportChange);
  }

  document.addEventListener('shopify:section:unload', function (event) {
    if (!activeState || !event.target.contains(activeState.card)) return;
    closeQuickAdd(false, true);
  });
})();
